import { Component } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { Train } from 'src/app/models/train.model';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Plant } from 'src/app/models/plant.model';
import { Unit } from 'src/app/models/unit.interface';
import { UserService } from 'src/app/services/user/user.service';
import { ModelsService } from 'src/app/services/models/models.service';
import { ToastrService } from 'ngx-toastr';
import { RawOpdata } from 'src/app/models/opdata.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';


@Component({
  selector: 'app-edit-opdata',
  templateUrl: './edit-opdata.component.html',
  styleUrls: ['./edit-opdata.component.scss']
})
export class EditOpdataComponent {
  plants: Plant[] = [];
  trains: Train[] = [];
  noOfStages:number = 0;
  ud1 : string = "User Defined 1";
  ud2 : string = "User Defined 2";
  ud3 : string = "User Defined 3";
  ud4 : string = "User Defined 4";
  ud5 : string = "User Defined 5";
  
  trainId:string;
  selectedTrain:Train=new Train();
  
  opdataModel:RawOpdata=new RawOpdata();
  plantId: number;
  dtoptions: DataTables.Settings = {};
  loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
  
  CurrentUserId = this.loggedInuserRole.userId;
  

  public units: Array<Unit> = [
    { Id: 0, UnitName: 'English' },
    { Id: 1, UnitName: 'Metric' },
  ];
    
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private userService: UserService,
    private modelService: ModelsService,
    private toastr : ToastrService,
    private opdataService:OpdataService
    
  ) { }

  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
    };
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
        if (id) {
          this.opdataService.getRawOpDataById(id).subscribe({
            next: (response) => {
              this.opdataModel = response;
              this.trainId = this.opdataModel.TrainId.toString();
    
              this.trainService.getTrainById(this.trainId).subscribe({
                next: (response) => {
                  // for showing selected plant and train from dashboard
                  this.plantService.setSelectedPlant(response.PlantId);
                  this.plantService.setSelectedTrain(response.Id);

                  this.selectedTrain = response;
                  console.log(this.selectedTrain);
                  this.noOfStages=this.selectedTrain.Stages;
                  if (this.selectedTrain.Ud1!=null) {
                    this.ud1=this.selectedTrain.Ud1
                  }
                  if (this.selectedTrain.Ud2!=null) {
                    this.ud2=this.selectedTrain.Ud2
                  }
                  if (this.selectedTrain.Ud3!=null) {
                    this.ud3=this.selectedTrain.Ud3
                  }
                  if (this.selectedTrain.Ud4!=null) {
                    this.ud4=this.selectedTrain.Ud4
                  }
                  if (this.selectedTrain.Ud5!=null) {
                    this.ud5=this.selectedTrain.Ud5
                  }
                  this.plantService.getAllPlant().subscribe({
                    next: (plants) => {
                      this.plants = plants;
                      this.plantId = this.plants.filter(
                        (x) => x.Id == this.selectedTrain.PlantId
                      )[0].Id;

                      this.trainService.getTrainByPlantId(this.plantId.toString()).subscribe(
                        (response: Train[]) => {
                          this.trains = response;
                          this.trainId = this.trains.filter(
                            (x) => x.Id == this.selectedTrain.Id
                          )[0].Id.toString();
                        },
                  
                        (error: any) => {
                          console.log('error list');
                        }
                      );
                      
                    },
                    error: (response) => {
                      console.log(response);
                    },
                  });

                  
                },
                error: (response) => {
                  console.log(response);
                },
              });    
            },
            error: (response) => {
              console.log(response);
            },
          });
        }
      }
    });
  }

  editRawOpData() {

    var rawOpdata = this.opdataModel;
    console.log(this.opdataModel);
    rawOpdata.AspNetUsersId=this.CurrentUserId;
    rawOpdata.Valid=1;
    this.opdataService.editRawOpdata( rawOpdata).subscribe({
      next: (model) => {
        this.toastr.success('Opdata and OpdataCalc Edited Successfully.', 'Information')
        this.router.navigate(['/opdata'], {
          queryParams: {PlantId: this.plantId, trainId: this.opdataModel.TrainId},
          skipLocationChange: true,
        });
      },
    });
  }
}
